import { I18n } from 'aws-amplify';

export const YEAR = {
    CODE: "YEARLY",
    TITLE: '年',
};
export const MONTH = {
    CODE: "MONTHLY",
    TITLE: '月',
};

export const CONTRACT_SCREEN_MANAGEMENT = {
    CONTRACT_VIEW_DETAIL: {
        SCREEN: 'CONTRACT_VIEW_DETAIL',
        REDIRECT_BUTTONS: [
            // {
            //     label: I18n.get('CM-BUTTON-PAYEMENT-MANAGEMENT'),
            //     outline: false,
            // },
            // {
            //     label: I18n.get('CM-BUTTON-CONTRACT-HISTORY'),
            //     outline: false,
            // },
            {
                label: I18n.get('CM-BUTTON-UPDATE-CONTRACT'),
                outline: true,
                defaultDisable: true
            }
        ]
    },
    CONTRACT_UPDATE: {
        SCREEN: 'CONTRACT_UPDATE',
        REDIRECT_BUTTONS: [
            {
                label: I18n.get('CM-BUTTON-CANCEL'),
                outline: true,
            },
            // {
            //     label: I18n.get('CM-BUTTON-SAVE-AS-DRAFT'),
            //     outline: false,
            // },
            // {
            //     label: I18n.get('CM-BUTTON-EXPORT-QUOTATION'),
            //     outline: false,
            // },
            {
                label: I18n.get('CM-BUTTON-UPDATE'),
                outline: true,
                defaultDisable: true
            }
        ]
    },
    CONTRACT_UPDATE_CONFRIM: {
        SCREEN: 'CONTRACT_UPDATE_CONFRIM',
        REDIRECT_BUTTONS: [
            {
                label: I18n.get('CM-BUTTON-CANCEL'),
                outline: true,
            },
            // {
            //     label: I18n.get('CM-BUTTON-EXPORT-QUOTATION'),
            //     outline: false,
            // },
            {
                label: I18n.get('CM-BUTTON-CONFIRM'),
                outline: true,
                defaultDisable: true
            }
        ],
        LABEL: {
            KIND_NEXT: 'next',
            KIND_BACK: 'cancel'
        }
    },
    CONTRACT_CHOOSE_PAYMENT_CONFRIM: {
        SCREEN: 'CONTRACT_CHOOSE_PAYMENT_CONFRIM',
        REDIRECT_BUTTONS: [
            {
                label: I18n.get('CM-BUTTON-CANCEL'),
                outline: true,
            },
            {
                label: I18n.get('CM-BUTTON-CONFIRM'),
                outline: true,
                defaultDisable: true
            }
        ],
        PAYMENT_METHOD: {
            BANK_TRANSFER: 'BANK_TRANSFER',
            CREDIT: 'credit',
            STRIPE: 'STRIPE',
            NONE: 'NONE'
        }
    },
    CONTRACT_POLICY: {
        SCREEN: "CONTRACT_POLICY",
        REDIRECT_BUTTONS: []
    }
};

export const CONTRACT_POLICY_CONTENT = [
    {
        term: '【利用目的】', 
        content: `アクセラテクノロジ株式会社（以下当社）が取得した個人情報は、当社及びセミナー主催・協賛企業においてセミナー業務、営業活動、セミナー・イベント案内および関連する情報のメルマガ配信、事業活動、業務上の連絡、お問い合わせ及びご依頼等の対応のために利用し、それ以外の目的で利用することはありません。`,
    },
    {
        term: '【第三者提供】', 
        content: `当社は、お預かりした個人情報をセミナー主催・協賛企業およびグループ会社に提供する場合があります。<br/>
        □提供目的：セミナー主催・協賛企業が前項に定める当社と同様の目的に利用すること<br/>
        □提供項目：氏名、役職、団体法人名、部署名、連絡先（ご住所、電話／FAX番号、電子メールアドレスを含む）<br/>
        □提供の手段・方法：電話、FAX、電子メール、郵送などの一般的な手段、方法<br/>
        前記の他、本人の同意がある場合又は法令の規定または司法手続きに基づく要請による場合を除き、取得した個人情報を第三者に提供することはありません。`,
    },
    {
        term: '【外部委託】', 
        content: `当社は、上記利用目的の達成のため、個人情報を委託することがあります。ただし、目的の範囲を超え、個人情報を使用させることはありません。`,
    },
    {
        term: '【情報提供の任意性】', 
        content: `当社への個人情報の提供は任意となっています。ただし、情報に漏れやミスがある場合、セミナーに関する手続きができない場合があります。`
    },
    {
        term: '【クッキーの使用について】', 
        content: `当社のホームページにおいて、閲覧されるお客様へのサービスの提供、トラフィック情報の検証の為、ユーザーのコンピューターにクッキー（Ｃｏｏｋｉｅ）と呼ぶ情報を送る場合があります。この情報はユーザーのコンピューターのハードディスクまたはメモリーに保存されます。クッキーの情報は当社ＨＰのマーケティング分析や各種サービス提供に限定して使用いたしますので、お客様のプライバシーを侵害することはありません。`
    },
    {
        term: '【個人情報の開示等】', 
        content: `利用目的の通知、個人情報の開示、内容の訂正、追加または削除、利用の停止、消去、第三者への提供の停止および第三者への提供に関する記録の開示、その他お問い合わせ等については、以下問い合わせ先までご一報ください。`
    },
];

export const FIELDS_VALIDATE = {
    GENERAL_USER: {
        TITLE: "numOfGeneralUser",
        RULES: {
            MAX_LENGTH: 20,
            MIN_VALUE: 1
        }
    },
    TICKET: "numOfTicket",
    TICKET_KNOWLEDGE: "numOfTicketKnowledge",
    STORAGE: "numOfStorage",
    QA_COUNTER: "numberOfQACounters",
    SUPPORT_COUNTER: "numberOfSupportedCounters",
    OTHER_RULES: {
        MAX_LENGTH: 8,
        MIN_VALUE: 0
    }
}
export const PAYMENT_CYCLE_LIST = [
    { id: 2, name: '年次', code: YEAR.CODE },
    { id: 1, name: '月次', code: MONTH.CODE }
]

export const PAYMENT_STATUS = {
    PROCESS: 'PROCESS',
    SUCCESS: 'SUCCESS',
    FAIL: 'FAIL'
}


export const CONTRACT_STATUS = {
    TRIAL: 'TRIAL',
    ACTIVE: 'ACTIVE',
    CANCELLED: "CANCELLED",
    EXPIRED: 'EXPIRED'
};